module.exports = __webpack_public_path__ + "assets/img/icon_music_play-58abd39e.png";